/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener( 'DOMContentLoaded', function () {
  new Splide('#splide', {
    type: 'loop',
    perPage: 1,
    autoWidth:true,
    arrows: false,
    focus: 'center',
    autoplay: false,
    // interval: 8000,
    // flickMaxPages: 3,
    // updateOnMove: true,
    pagination: false,
    // padding: '10%',
    // throttle: 300,
    autoScroll: {
      speed: 1,
    } 
  }).mount(window.splide.Extensions);
});

// Sticky Tabs JS
$(document).ready(function() {
  if($('.PageHeaders').length){  
  var elementPosition = $('.PageHeaders').offset();
var stickyTop = $('#section-header').height();
  // alert(stickyTop);
$(window).scroll(function(){
	 if($(window).scrollTop() > elementPosition.top){
	$('.PageHeaders').css('position','fixed').css('top',stickyTop+'px').addClass('sticky');
	} else {
	$('.PageHeaders').css('position','static');
	}    
  });
  }
});

// smooth scroll tabs
$('.tabs li:first-child a').addClass('active');
$('.tabs li a').click(function(){
    var t = $(this).attr('href');
  if($(this).hasClass('active')){ //this is the start of our condition 
    $('.tabs li a').removeClass('active');           
    $(this).addClass('active');
 }
});
function scrollNav() {
  $('.tabs li a').click(function(){
    $(".collection-name-link").removeClass("active");     
    $(this).addClass("active");
    
    $('html, body').stop().animate({
      scrollTop: $($(this).attr('href')).offset().top - 180
    }, 1000);
    return false;
  });
}
scrollNav();


/*-----------------------------------------------
    Product Page Thumbnail Slider
-----------------------------------------------*/ 

$(document).ready(function() {
  // setTimeout(function() {
  //     $('.Product__Gallery').find('.Product__NavSlider').find(".flickity-slider").find("a:first").css({"left": "0"});
  // }, 600); 
  
 $('.Product__NavSlider .previous').on( 'click', function() {
     //$("input").trigger("select");
   $('.Product__SlideshowMobileNav .Product__SlideshowNavArrow--previous').trigger("click");
  });

   $('.Product__NavSlider .next').on( 'click', function() {
     //$("input").trigger("select");
   $('.Product__SlideshowMobileNav .Product__SlideshowNavArrow--next').trigger("click");
  });

  if($(".template-cart").length){

           $('body').on('change', '.QuantitySelector__CurrentQuantity_select_opt', function() { 
             var get_qty_obj = $(this);
             var get_qty_val = $(this).val();

             get_qty_obj.find("option").removeAttr("selected");
            
             get_qty_obj.find("option").each(function(){
               var get_add_on_option_text = $(this).val();
                  if(get_add_on_option_text== get_qty_val){
                      $(this).attr("selected", "true");                  
                  }
              }); 
             
               $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val(get_qty_val);
              var get_df =  $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val();
             //alert("default value "+get_df);
               //$(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val(get_qty_val).trigger("change");
               var get_opt_id = $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").attr("id");
               var get_opt_variant_id = $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").attr("data-item-variant-id");
  

                  var get_qty_val_data = {
                    "id": get_opt_variant_id,
                    "quantity": get_qty_val
                  }
                  jQuery.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: get_qty_val_data,
                    dataType: 'json',
                    success: function(wp_response) { 
                        //window.location.href = '/cart'; 
                        //alert("Added Warranty");
                        let ref_element = document.getElementById(get_opt_id);
                        ref_element.value = get_df;
                        ref_element.dispatchEvent(new Event('change', { 'bubbles': true }));    
                      //get_qty_obj.closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val(get_qty_val).trigger("change");
                      //document.dispatchEvent(new CustomEvent('cart:refresh'));
                        //alert(get_opt_variant_id+"df = "+get_qty_val);                                      
                    }
                  }); 
            
          });      
    
    /*
       $('body').on('change', '.QuantitySelector__CurrentQuantity_select_opt', function() { 
         var get_qty_obj = $(this);
         var get_qty_val = $(this).val();

          
         $(this).closest(".QuantitySelector").find(".QuantitySelector__Button_plus").attr("data-quantity",get_qty_val);
         var get_item_line = $(this).closest(".QuantitySelector").find(".QuantitySelector__Button_plus").attr("data-line");
         var set_qty_url = "/cart/change?quantity="+get_qty_val+"&line="+get_item_line;
         $(this).closest(".QuantitySelector").find(".QuantitySelector__Button_plus").attr("href",set_qty_url);
         $(this).closest(".QuantitySelector").find(".QuantitySelector__Button_minus").attr("href",set_qty_url);

         $(this).closest(".CartItem__Actions").find(".CartItem__Remove").attr("href",set_qty_url);
         $(this).closest(".CartItem__Actions").find(".CartItem__Remove").attr("data-quantity",get_qty_val);

         var get_current_qty = $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val();

         if(get_qty_val >get_current_qty){
              setTimeout(function(){ 
                           var get_opt_id = get_qty_obj.closest(".QuantitySelector").find(".QuantitySelector__Button_plus").attr("id");
                            let element = document.getElementById(get_opt_id);
                            element.dispatchEvent(new Event('click', { 'bubbles': true }));                     
              }, 1000);   
         }else{

              setTimeout(function(){ 
                           var get_opt_id = get_qty_obj.closest(".QuantitySelector").find(".QuantitySelector__Button_minus").attr("id");
                            let element = document.getElementById(get_opt_id);
                            element.dispatchEvent(new Event('click', { 'bubbles': true }));                     
              }, 1000); 
         }

        //alert("df = "+get_qty_val);   
      });  
*/
  }else{
       $('body').on('change', '.QuantitySelector__CurrentQuantity_select_opt', function() { 
         var get_qty_obj = $(this);
         var get_qty_val = $(this).val();
         $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").val(get_qty_val).trigger("change");
         var get_opt_id = $(this).closest(".QuantitySelector").find(".QuantitySelector__CurrentQuantity").attr("id");
        let element = document.getElementById(get_opt_id);
        element.dispatchEvent(new Event('change', { 'bubbles': true }));          
        //alert("df = "+get_qty_val);   
      });     
  }
 

});

/*-----------------------------------------------
    Mobile menu drawer swipe script
-----------------------------------------------*/ 

$('[data-drawer-id="sidebar-menu"]').click(function(event) {
 //$('body').addClass('PageOverlay__hide');
  //$("body").toggleClass("PageOverlay__mobile");

  if($("body").hasClass("PageOverlay__mobile"))
  {
    setTimeout(function() {
       $("body").removeClass("PageOverlay__mobile");
   }, 800); 
  }else{
     $("body").addClass("PageOverlay__mobile");
  }
});

//open menu level
$("#sidebar-menu summary").on( "click", function(index) {
  openSidebarMenu($(this));
});

var mainDetailsToggle =  $('.SidebarMenu').find('details');
var submeu = $('.SidebarMenu').find('.has-submenu');
var TopDrawerHeader =  $('.SidebarMenu').find('.Drawer__Header--top');
var InnerDrawerHeader =  $('.SidebarMenu').find('.Drawer__Header--inner');

//close menu level
$('.menu-drawer__submenu .menu-drawer__close-button').on("click", function(){
   closeSidebarMenu($(this));
}); 

function openSidebarMenu(elem) {
 // setTimeout(function() {
    elem.parent().addClass('menu-opening');
    elem.parent().closest('.has-submenu').addClass('submenu-open');
    elem.parent().closest('.SidebarMenu__Nav').siblings().addClass('hide');
    elem.attr('aria-expanded', true);
   TopDrawerHeader.addClass('hide');
  // }, 100);  
}

function closeSidebarMenu(closetarget) {
 setTimeout(function() {
   //$('.menu-opening').removeAttr('open');
   mainDetailsToggle.removeClass('menu-opening');
   submeu.removeClass('submenu-open');
   submeu.closest('.SidebarMenu__Nav').siblings().removeClass('hide');
   closetarget.parent().parent().closest('summary').attr('aria-expanded', false);
   closetarget.closest('.has-submenu').closest('details').removeAttr('open');
    TopDrawerHeader.removeClass('hide');
  }, 100);  
}  

/*---------------------------------------
          FAQ Script 
---------------------------------------*/ 
$(".FaqSummary__select").click(function() {
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(".FaqSummary__select li").click(function() {

  var selected_value = $(this).html();
  var first_li = $(".FaqSummary__select li:first-child").html();

  $(".FaqSummary__select li:first-child").html(selected_value);
  $(this).html(first_li);

});

/*---------------------------------------
       Account Pages Dropwdwon
---------------------------------------*/ 
jQuery('.account-tabs__mobile').each(function(){
    jQuery(this).on('click',  function(e){
      var is_open = $(this).hasClass("open");
        if (is_open) {
          $(this).removeClass("open");
        } else {
          $(this).addClass("open");
        }
       return false;
    });

     jQuery(this).on('click', 'a', function(eve){
      var content = jQuery(this).attr('href');
       window.location.href = content;
        return false;
     });
 });
/*---------------------------------------
       Account Pages Form Hide/Show
---------------------------------------*/         
   
jQuery('.account-tabs__btn').each(function(){
   var $active, $content, $links = jQuery(this).find('a');
    $active = jQuery($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $content = $($active[0].hash);
  
    // Hide the remaining content
    $links.not($active).each(function () {
        jQuery(this.hash).hide();
    });

    // Bind the click event handler
    jQuery(this).on('click', 'a', function(e){
      
    // Make the old tab inactive
    $content.hide();

    // Make the siblings tab inactive 
    $('.account-tabs__btn').removeClass('active');
    var $other_content  = jQuery(this.hash);
    $other_content.siblings('.PageLayout-Section__content').hide();
      
        // Update the variables with the new link and content
        $active = jQuery(this);
        $content = jQuery(this.hash);

        // Make the tab active.
       $(this).parent().addClass('active');
        $content.show();

      if($(this).hasClass('Segment-Action__edit')){
       var EditModel = $(this).attr('aria-controls');
         $('.Section-address__edit').find('.Form-address__edit').attr('aria-hidden',true);  
        $('.Section-address__edit').find('#'+EditModel).attr('aria-hidden',false);  
        console.log(EditModel);
      }

        // Prevent the anchor's default click action
       return false; 
    });
});

/*--------------------------------
      Detect user device
--------------------------------*/ 

  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
  var result = "Is it Safari: " + isSafari;
  console.log(result);

  if( isSafari) {
      $('html').addClass('Safari__device');
  } else {
     $('html').removeClass('Safari__device');
  }

if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  $("html").addClass("mac_os");
} else {
  $("html").addClass("normal_os");
}

 var isChrome = /chrome/.test( navigator.userAgent.toLowerCase() );
 if( isChrome) {
      $('html').addClass('chrome_browser'); 
  }


/*--------------------------------------
       Common Tabs
--------------------------------------*/ 
// Nested Tabs script
jQuery('.tabs__container').each(function(){
    // which tab is active and it's associated content
    var $active_tab, $content_div, $links_tab = jQuery(this).find('a');

    // If the location.hash matches one of the links, use that as the active tab.
    $active_tab = jQuery($links_tab.filter('[href="'+location.hash+'"]')[0] || $links_tab[0]);
    $active_tab.addClass('active');

    $content_div = $($active_tab[0].hash);
  
    // Hide the remaining content
    $links_tab.not($active_tab).each(function () {
        jQuery(this.hash).hide();
    });

    // Bind the click event handler
    jQuery(this).on('click', 'a', function(e){
      
        // Make the old tab inactive.
        $active_tab.parent().removeClass('active');
        $content_div.hide();

    // Make the siblings tab inactive 
      jQuery(this).parent().siblings('.active').removeClass('active');
      var $other_content_con  = jQuery(this.hash);
      $other_content_con.siblings('.tab-content_container').hide();
      
        // Update the variables with the new link and content
        $active_tab = jQuery(this);
        $content_div = jQuery(this.hash);

        // Make the tab active.
        $active_tab.parent().addClass('active');
        $content_div.show();

        // Prevent the anchor's default click action
        return false;
    });
        
});

/*--------------------------------------
    Blog Carousel
--------------------------------------*/ 
if($(".blogs__carousel").length){
    $('.blogs__carousel').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
}


           
